import { useNavigate, useParams, useLocation } from 'react-router-dom';

/**
 * Higher-Order Component to provide router props to class components
 * This replaces the removed withRouter from React Router v5
 * 
 * Usage:
 * export default withRouter(YourComponent);
 * 
 * Then access via props:
 * - this.props.navigate (function) - replaces history.push()
 * - this.props.params (object) - replaces match.params
 * - this.props.location (object) - current location
 */
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    
    return (
      <Component
        {...props}
        navigate={navigate}
        params={params}
        location={location}
      />
    );
  }

  return ComponentWithRouterProp;
}
